import React, { useEffect, useState } from 'react';
import { ToastContainer } from 'react-toastify';

import OnlineCheck from 'components/extra/OnlineCheck';
import MaintenanceBreak from 'components/MaintenanceBreak';
import VersionWatcher from 'components/VersionWatcher';
import { AppContext } from './context';
import { REACT_TOASTIFY_CONTAINER_ID } from 'components/Toast';

export function AppProvider({ children = null }) {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return (
    <AppContext.Provider value={{ isOnline }}>
      <OnlineCheck />
      <ToastContainer
        enableMultiContainer
        containerId={REACT_TOASTIFY_CONTAINER_ID}
      />
      <VersionWatcher />
      <MaintenanceBreak>{children}</MaintenanceBreak>
    </AppContext.Provider>
  );
}
